var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19 25",
    style: {
      enableBackground: "new 0 0 19 25"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3215F",
    d: "M17.1,3.7C15.2,1.3,12.5,0,9.5,0S3.8,1.3,1.9,3.7c-2.6,3.4-2.6,8.1,0,11.5L9.5,25l7.6-9.8C19.6,11.8,19.6,7.1,17.1,3.7z M9.5,15c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S12.2,15,9.5,15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.3ab3a64066224738d761774d6adc4790.svg";
export { ForwardRef as ReactComponent };